import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'StatsGroup';

const StatsGroupApi: any = baseApi(endpoint);

export default StatsGroupApi;